<template>
    <div class="not-found">
        <div class="not-found__background">
            <div class="floating-shapes">
                <div class="shape shape--1"></div>
                <div class="shape shape--2"></div>
                <div class="shape shape--3"></div>
            </div>
        </div>
        
        <div class="not-found__container">
            <div class="not-found__content">
                <!-- 404 Number -->
                <div class="not-found__number">
                    <span class="digit digit--4">4</span>
                    <span class="digit digit--0">
                        <div class="zero-ring">
                            <div class="zero-inner"></div>
                        </div>
                    </span>
                    <span class="digit digit--4">4</span>
                </div>
                
                <!-- Error Message -->
                <div class="not-found__message">
                    <h1 class="not-found__title">{{ currentTitle }}</h1>
                    <p class="not-found__subtitle">{{ currentSubtitle }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NotFound",
    data() {
        return {
            titles: [
                'Sayfa Bulunamadı',
                'Page Not Found',
                'Página No Encontrada',
                'Page Non Trouvée'
            ],
            subtitles: [
                'Aradığınız sayfa mevcut değil veya taşınmış olabilir.',
                'The page you are looking for might not exist or has been moved.',
                'La página que buscas no existe o ha sido movida.',
                'La page que vous recherchez n\'existe pas ou a été déplacée.'
            ],
            currentTitleIndex: 0,
            currentTitle: '',
            currentSubtitle: ''
        };
    },
    mounted() {
        this.initializeText();
    },
    methods: {
        initializeText() {
            this.currentTitle = this.titles[0];
            this.currentSubtitle = this.subtitles[0];
            
            // Change language every 4 seconds
            setInterval(() => {
                this.currentTitleIndex = (this.currentTitleIndex + 1) % this.titles.length;
                this.currentTitle = this.titles[this.currentTitleIndex];
                this.currentSubtitle = this.subtitles[this.currentTitleIndex];
            }, 4000);
        }
    }
};
</script>

<style lang="scss" scoped>
.not-found {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.not-found__background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
        rgba(99, 102, 241, 0.05) 0%, 
        rgba(139, 92, 246, 0.08) 50%, 
        rgba(16, 185, 129, 0.05) 100%);
    backdrop-filter: blur(30px);
}

.floating-shapes {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.shape {
    position: absolute;
    border-radius: 50%;
    background: linear-gradient(135deg, 
        rgba(99, 102, 241, 0.08), 
        rgba(139, 92, 246, 0.08));
    animation: float 8s ease-in-out infinite;
}

.shape--1 {
    width: 60px;
    height: 60px;
    top: 20%;
    left: 15%;
    animation-delay: 0s;
}

.shape--2 {
    width: 40px;
    height: 40px;
    top: 60%;
    right: 25%;
    animation-delay: -3s;
}

.shape--3 {
    width: 50px;
    height: 50px;
    bottom: 30%;
    left: 70%;
    animation-delay: -6s;
}

@keyframes float {
    0%, 100% {
        transform: translateY(0px) translateX(0px) rotate(0deg);
        opacity: 0.4;
    }
    50% {
        transform: translateY(-15px) translateX(8px) rotate(180deg);
        opacity: 0.6;
    }
}

.not-found__container {
    position: relative;
    z-index: 10;
    max-width: 600px;
    width: 90%;
    padding: 3rem 2rem;
    background: linear-gradient(145deg, 
        rgba(255, 255, 255, 0.95) 0%,
        rgba(255, 255, 255, 0.85) 100%);
    backdrop-filter: blur(50px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 1.5rem;
    box-shadow: 
        0 20px 40px rgba(0, 0, 0, 0.08),
        0 0 0 1px rgba(255, 255, 255, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.3);
    text-align: center;
    animation: containerFloat 8s ease-in-out infinite;
}

@keyframes containerFloat {
    0%, 100% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(-5px);
    }
}

.not-found__content {
    position: relative;
}

.not-found__number {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
    gap: 0.5rem;
}

.digit {
    font-size: clamp(4rem, 12vw, 8rem);
    font-weight: 800;
    background: linear-gradient(135deg, var(--primary), var(--secondary));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: digitPulse 3s ease-in-out infinite;
}

.digit--4:first-child {
    animation-delay: 0s;
}

.digit--4:last-child {
    animation-delay: 0.6s;
}

@keyframes digitPulse {
    0%, 100% {
        transform: scale(1);
        filter: brightness(1);
    }
    50% {
        transform: scale(1.02);
        filter: brightness(1.1);
    }
}

.zero-ring {
    position: relative;
    width: clamp(4rem, 12vw, 8rem);
    height: clamp(4rem, 12vw, 8rem);
    border: 6px solid;
    border-image: linear-gradient(135deg, var(--primary), var(--secondary)) 1;
    border-radius: 50%;
    animation: rotate 6s linear infinite;
    display: flex;
    align-items: center;
    justify-content: center;
}

.zero-inner {
    width: 60%;
    height: 60%;
    border: 3px solid;
    border-image: linear-gradient(45deg, var(--secondary), var(--accent)) 1;
    border-radius: 50%;
    animation: rotateReverse 4s linear infinite;
}

@keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

@keyframes rotateReverse {
    from { transform: rotate(360deg); }
    to { transform: rotate(0deg); }
}

.not-found__message {
    margin-bottom: 0;
}

.not-found__title {
    font-size: clamp(1.5rem, 4vw, 2.5rem);
    font-weight: 700;
    background: linear-gradient(135deg, var(--primary), var(--secondary));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 1rem;
    animation: titleFade 0.5s ease-in-out;
}

.not-found__subtitle {
    font-size: clamp(0.9rem, 2vw, 1.1rem);
    color: var(--text-secondary);
    line-height: 1.6;
    max-width: 500px;
    margin: 0 auto;
    animation: titleFade 0.5s ease-in-out 0.2s both;
}

@keyframes titleFade {
    from {
        opacity: 0;
        transform: translateY(15px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .not-found__container {
        padding: 2.5rem 1.5rem;
        width: 95%;
        border-radius: 1.25rem;
    }
    
    .not-found__number {
        gap: 0.25rem;
        margin-bottom: 1.5rem;
    }
}

@media (max-width: 480px) {
    .not-found__container {
        padding: 2rem 1.25rem;
        border-radius: 1rem;
    }
    
    .not-found__number {
        margin-bottom: 1rem;
    }
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
    .not-found__background {
        background: linear-gradient(135deg, 
            rgba(15, 23, 42, 0.95) 0%, 
            rgba(30, 41, 59, 0.97) 100%);
    }
    
    .not-found__container {
        background: linear-gradient(145deg, 
            rgba(31, 41, 55, 0.95) 0%,
            rgba(17, 24, 39, 0.9) 100%);
        border: 1px solid rgba(55, 65, 81, 0.3);
        box-shadow: 
            0 20px 40px rgba(0, 0, 0, 0.3),
            0 0 0 1px rgba(55, 65, 81, 0.3),
            inset 0 1px 0 rgba(255, 255, 255, 0.1);
    }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
    .digit,
    .zero-ring,
    .zero-inner,
    .shape,
    .not-found__container {
        animation: none;
    }
}
</style>
